import { render, staticRenderFns } from "./MyReviews.vue?vue&type=template&id=123cdcee&scoped=true&"
import script from "./MyReviews.vue?vue&type=script&lang=ts&"
export * from "./MyReviews.vue?vue&type=script&lang=ts&"
import style0 from "./MyReviews.vue?vue&type=style&index=0&id=123cdcee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123cdcee",
  null
  
)

export default component.exports